/**
 * 上传场景常量
 * 用于区分不同场景的图片/视频上传，后端会根据场景进行不同的审核策略
 */
export const UPLOAD_SCENE = {
  /** 任务创建（默认） */
  VIDU: 'vidu',
  /** 投稿短片/教程 */
  COMMUNITY: 'community',
  /** 编辑头像 */
  AVATAR: 'avatar',
  /** 主体创建 */
  MATERIAL: 'material',
  /** Agent */
  AGENT: 'agent',
  /** Motion Control */
  MOTION: 'motion',
  /** AI 数字人 */
  AI_AVATAR: 'ai-avatar',
} as const;

export type UploadScene = (typeof UPLOAD_SCENE)[keyof typeof UPLOAD_SCENE];
